export const IkanoIDFrontIcon = () => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="120" height="120" rx="60" fill="#F7F9FC" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.0007 45.3334C38.5279 45.3334 37.334 46.5273 37.334 48V58.6667C37.334 60.1395 38.5279 61.3334 40.0007 61.3334H50.6673C52.1401 61.3334 53.334 60.1395 53.334 58.6667V48C53.334 46.5273 52.1401 45.3334 50.6673 45.3334H40.0007ZM50.6673 47.6H40.0007C39.7797 47.6 39.6007 47.7791 39.6007 48V58.6667C39.6007 58.8876 39.7797 59.0667 40.0007 59.0667H50.6673C50.8882 59.0667 51.0673 58.8876 51.0673 58.6667V48C51.0673 47.7791 50.8882 47.6 50.6673 47.6Z"
        fill="#EC0000"
      />
      <path
        d="M36.2005 73.3334C36.2005 72.7075 36.7079 72.2001 37.3339 72.2001H44.4172C45.0431 72.2001 45.5505 72.7075 45.5505 73.3334C45.5505 73.9593 45.0431 74.4667 44.4172 74.4667H37.3339C36.7079 74.4667 36.2005 73.9593 36.2005 73.3334Z"
        fill="#EC0000"
      />
      <path
        d="M48.9505 73.3334C48.9505 72.7075 49.4579 72.2001 50.0839 72.2001H57.1672C57.7931 72.2001 58.3005 72.7075 58.3005 73.3334C58.3005 73.9593 57.7931 74.4667 57.1672 74.4667H50.0839C49.4579 74.4667 48.9505 73.9593 48.9505 73.3334Z"
        fill="#EC0000"
      />
      <path
        d="M62.8339 72.2001C62.2079 72.2001 61.7005 72.7075 61.7005 73.3334C61.7005 73.9593 62.2079 74.4667 62.8339 74.4667H69.9172C70.5431 74.4667 71.0505 73.9593 71.0505 73.3334C71.0505 72.7075 70.5431 72.2001 69.9172 72.2001H62.8339Z"
        fill="#EC0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.334 50.6667C77.334 53.6122 74.9462 56 72.0007 56C69.0551 56 66.6673 53.6122 66.6673 50.6667C66.6673 47.7212 69.0551 45.3334 72.0007 45.3334C74.9462 45.3334 77.334 47.7212 77.334 50.6667ZM75.0673 50.6667C75.0673 52.3604 73.6943 53.7334 72.0007 53.7334C70.307 53.7334 68.934 52.3604 68.934 50.6667C68.934 48.973 70.307 47.6 72.0007 47.6C73.6943 47.6 75.0673 48.973 75.0673 50.6667Z"
        fill="#EC0000"
      />
      <path
        d="M86.4672 69.3333C86.4672 68.8977 86.2175 68.5006 85.8248 68.3119C85.4322 68.1231 84.9661 68.1762 84.6259 68.4483L81.2926 71.115C80.8038 71.506 80.7246 72.2192 81.1156 72.708C81.5066 73.1968 82.2198 73.276 82.7086 72.885L84.2006 71.6914V78.6667C84.2006 79.2926 84.708 79.8 85.3339 79.8C85.9598 79.8 86.4672 79.2926 86.4672 78.6667V69.3333Z"
        fill="#EC0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.334 42.4667C29.334 39.6316 31.6323 37.3334 34.4673 37.3334H85.134C87.969 37.3334 90.2673 39.6316 90.2673 42.4667V62.857C94.3416 64.9068 97.1339 69.125 97.1339 74.0001C97.1339 80.8798 91.5583 86.4667 84.6672 86.4667C80.9498 86.4667 77.6151 84.8435 75.332 82.2667H34.4673C31.6323 82.2667 29.334 79.9684 29.334 77.1334V42.4667ZM73.7346 80C72.7566 78.2204 72.2005 76.1757 72.2005 74.0001C72.2005 69.3195 74.7744 65.2444 78.5857 63.1126C77.0901 61.1009 74.6966 59.8001 72.0005 59.8001C67.8705 59.8001 64.4519 62.8544 63.8836 66.8272C63.795 67.4468 63.2209 67.8773 62.6013 67.7887C61.9816 67.7 61.5512 67.1259 61.6398 66.5063C62.3655 61.4329 66.7267 57.5334 72.0005 57.5334C75.6274 57.5334 78.822 59.3785 80.699 62.1771C81.9453 61.7596 83.2796 61.5334 84.6672 61.5334C85.8219 61.5334 86.9398 61.69 88.0007 61.9833V42.4667C88.0007 40.8835 86.7172 39.6 85.134 39.6H34.4673C32.8841 39.6 31.6007 40.8835 31.6007 42.4667V77.1334C31.6007 78.7166 32.8841 80 34.4673 80H73.7346ZM84.6672 63.8001C79.0286 63.8001 74.4672 68.3625 74.4672 74.0001C74.4672 79.6376 79.0286 84.2001 84.6672 84.2001C90.3052 84.2001 94.8672 79.6292 94.8672 74.0001C94.8672 68.3625 90.3058 63.8001 84.6672 63.8001Z"
        fill="#EC0000"
      />
    </svg>
  )
}
